import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface SeatsForSave {
  totalSeats: number
  minimumAllowedSeats: number
  nextBillingDate: Date
}

const getSeatsForSave = (planPeriodId: string): Promise<any> => {
  return adminHttpClient.get(`/AdminDashboard/Seat/GetSeatsForSave/${planPeriodId}`)
}

export default getSeatsForSave
